import { Link } from "react-router-dom";

import "./project-card.scss";

import { useContext } from "react";
import { Context } from "../../../utils/main-context/MainContext";

import CardImage1 from "../../../assets/images/maybach-shop/1.png";
import CardImage2 from "../../../assets/images/maybach-dash/1.png";
import CardImage3 from "../../../assets/images/gi-group/1.png";
import CardImage4 from "../../../assets/images/project-backend/1.png";

const ProjectCard = ({ data }) => {
  const { callOnlyWorkHero } = useContext(Context);

  return (
    <Link
      to={`/work/${data.id}`}
      onClick={() => callOnlyWorkHero()}
      className="project-card"
    >
      {data.id === "1" && <img src={CardImage1} alt={data.name} />}
      {data.id === "2" && <img src={CardImage2} alt={data.name} />}
      {data.id === "3" && <img src={CardImage3} alt={data.name} />}
      {data.id === "4" && <img src={CardImage4} alt={data.name} />}
      <h2 className="card-title">{data.name}</h2>
    </Link>
  );
};

export default ProjectCard;
